// extracted by mini-css-extract-plugin
export default {"collapse":"ProjectRow-module__collapse___krxSK","disabled":"ProjectRow-module__disabled___dTKB9","allowInteraction":"ProjectRow-module__allowInteraction___geS6w"};